// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import {
    autocompleteCategoriesStyles as autocompleteCommonStyles,
    AutocompleteCategoriesStyles as AutocompleteCommonStyles,
} from "@mcmc/Overrides/Widgets/Header/AutocompleteCategories";
import mergeToNew from "@mcmc/XDL/Utilities/xMergeToNew";
import React from "react";

interface Props {
    content: AutocompleteItemModel[] | null;
    focusedItem?: AutocompleteItemModel;
    doSearch: (resultsSectionId: string) => void;
    goToUrl: (url: string) => void;
    extendedStyles?: AutocompleteContentStyles;
}

export interface AutocompleteContentStyles extends AutocompleteCommonStyles {}

export const autocompleteContentStyles: AutocompleteContentStyles = {
    ...autocompleteCommonStyles,
};

const styles = autocompleteContentStyles;

class AutocompleteContent extends React.Component<Props> {
    private readonly styles: AutocompleteContentStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
        this.doSearchPages = this.doSearchPages.bind(this);
        this.doSearchResources = this.doSearchResources.bind(this);
    }

    doSearchPages() {
        this.props.doSearch("page");
    }

    doSearchResources() {
        this.props.doSearch("resource");
    }

    render() {
        const { content, focusedItem } = this.props;
        if (!content || content.length === 0) {
            return null;
        }

        const styles = this.styles;
        return (
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.heading}>
                    <Typography
                        {...styles.headerText}
                        data-test-selector="autocompleteContent_Header"
                        className="autocomplete-content-header"
                    >
                        {translate("Content")}
                    </Typography>
                    <StyledWrapper>
                        <Link onClick={this.doSearchPages} {...styles.headerLink}>
                            {translate("View Pages")}
                        </Link>
                        <Link onClick={this.doSearchResources} {...styles.headerLink}>
                            {translate("View Resources")}
                        </Link>
                    </StyledWrapper>
                </StyledWrapper>
                {content.map(content => (
                    <StyledWrapper key={content.url} {...styles.item[styles.getStyleType(content, focusedItem)]}>
                        <Link
                            {...styles.link[styles.getStyleType(content, focusedItem)]}
                            onClick={() => {
                                this.props.goToUrl(content.url);
                            }}
                            data-test-selector="autocompleteContent_Result"
                            className="autocomplete-content-link"
                        >
                            {content.displayTitle}
                        </Link>
                    </StyledWrapper>
                ))}
            </StyledWrapper>
        );
    }
}

export default AutocompleteContent;
